import { Autocomplete } from '@mui/material';
import * as styles from './styles.css';

import { IInternalSingleSelectProps } from './index';
import BaseInput from '../input/base-input';

const BaseSingleSelect = ({
  id,
  className,
  label,
  options,
  value,
  error,
  placeholder,
  required,
  onSelect,
  freeSolo = false,
  onChange,
}: IInternalSingleSelectProps) => {
  return (
    <Autocomplete
      id={id}
      freeSolo={freeSolo}
      className={className ?? styles.single_select}
      value={value}
      onChange={(_, value) => onSelect(value ?? '')}
      options={options}
      renderInput={(params) => {
        const handleChange = onChange
          ? (value) => {
              onChange(value);
              onSelect(value);
            }
          : undefined;
        return (
          <BaseInput
            placeholder={placeholder}
            label={label}
            required={required}
            error={error}
            onChange={handleChange}
            {...params}
          />
        );
      }}
    />
  );
};

export default BaseSingleSelect;
